import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  title: 'Post-lancio',
  subtitle: 'Visualizza i dati della checklist Go Live e imposta la data di verifica post-lancio.',
  go_live_checklist: {
    labels: {
      yes: 'Sì',
      no: 'No',
    },
    title: 'Checklist Go Live',
    form: {
      is_google_business_available: {
        label: 'Google Business disponibile',
      },
      is_smart_pricing_configured: {
        label: 'Prezzi più bassi di Lieferando, Wolt, Uber',
      },
      is_flyers_package_sent: {
        label: 'Volantino promozionale inviato',
      },
      is_menu_fully_configured: {
        label: 'Tutti i piatti del menu disponibili',
      },
      has_offers_on_competitor_platforms: {
        label: 'Il ristorante ha offerte attive su Wolt, Uber, Lieferando (escluse le offerte di consegna gratuita)?',
      },
      is_instagram_story_shared: {
        label: 'Instagram story condivisa con il proprietario',
      },
      is_order_system_connected_to_website: {
        label: 'Sito Foodamigos collegato O pulsante ordine online aggiunto al sito del ristorante',
      },
      google_business_connected_by: {
        label: "Come abbiamo ottenuto l'accesso al profilo Google Business?",
        options: {
          [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Il sales manager ha invitato google@foodamigos.io',
          [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
            'Il sales manager ha inviato la prima richiesta dal telefono del proprietario',
          [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
            "L'onboarding manager ha richiesto il profilo Google Business (il SM non ha invitato né richiesto l'accesso)",
          null: 'N/A',
        },
      },
    },
    buttons: {
      save: 'Salva',
    },
    toasts: {
      success: 'Salvato con successo',
      error: 'Salvataggio non riuscito',
    },
  },
  post_launch_screening: {
    title: 'Verifica post-lancio',
    form: {
      screening_date: {
        label: 'Data di verifica',
      },
    },
    toasts: {
      success: 'Salvato con successo',
      error: 'Salvataggio non riuscito',
    },
    buttons: {
      save: 'Salva',
    },
  },
};
